import React from 'react'
import { Block, ListWithContent } from '@components'

const DatoCmsListWithContent = ({
  paddingTop,
  paddingBottom,
  backgroundColour,
  ...props
}) => {
  return (
    <Block
      gutters
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      backgroundColour={backgroundColour}
    >
      <ListWithContent {...props} />
    </Block>
  )
}

export default DatoCmsListWithContent
